import { makeStyles } from '@mui/styles';
import { Button, Container, Grid, Typography } from '@mui/material';
import ConfiguracaoInstituicaoContainer from './Instituicao/ConfiguracaoInstituicaoContainer';
import { useState } from 'react';
import ConfiguracaoInstituicaoProvidenceContainer from './InstituicaoProvidence/ConfiguracaoInstituicaoProvidenceContainer';
import { useSelector } from 'react-redux';
import { ADMIN, COORDENADOR, SECRETARIA } from '../Usuario/Perfil';
import GridPaper from '../../util/GridPaper';

const useStyles = makeStyles({
    usuarioPerfilTable: {
        marginTop: '30px'
    },
    container: {
        marginTop: '15px'
    }
});


export default function ConfiguracaoContainer() {
    const classes = useStyles();
    const instituicaoKey = 'instituicao';
    const instituicaoProvidenceKey = 'instituicaoProvidence';
    const [menu, setMenu] = useState(instituicaoKey);
    const usuario = useSelector(state => state.usuario);

    return (
        <Container className={classes.container} >
            <Grid container spacing={3} direction='column'>
                <Grid>
                    <Typography variant="h5">
                        Configurações
                    </Typography>
                </Grid>
                {usuario.perfil === ADMIN ||
                    usuario.perfil === COORDENADOR ||
                    usuario.perfil === SECRETARIA ?
                    <GridPaper >
                        <Grid container spacing={3} direction='row'>
                            <Grid>
                                <Button onClick={() => setMenu(instituicaoKey)} variant='outlined'>Instituição</Button>
                            </Grid>

                            <Grid>
                                <Button
                                    onClick={() => setMenu(instituicaoProvidenceKey)}
                                    variant='outlined'>
                                    Instituição Providence
                                </Button>
                            </Grid>


                        </Grid>

                    </GridPaper> :
                    ''
                }

                {/* <Grid item xs={12}>
                    <Divider />
                </Grid> */}
                <Grid>
                    {menu === instituicaoKey ?
                        <ConfiguracaoInstituicaoContainer /> :
                        <ConfiguracaoInstituicaoProvidenceContainer />
                    }
                </Grid>

            </Grid>
        </Container>
    );
}